import generateHandleActions from 'redux/state-handler';
import {
  GET_PRODUCTS,
  GET_PRODUCT_NAMES,
  GET_PRODUCT_SUBNAMES,
} from 'redux/constants';

const apiStates = [
  { type: GET_PRODUCTS, name: 'products' },
  { type: GET_PRODUCT_NAMES, name: 'productNames' },
  { type: GET_PRODUCT_SUBNAMES, name: 'productSubnames' },
];

const instantStates = [];
const storage = {};
const listValues = ['products', 'productNames', 'productSubnames'];

export default generateHandleActions({ apiStates, instantStates, storage, listValues });
